var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};


site.frontpage = {
	init: function() {

	}
};
site.oldStyles = {
	init: function () {
		$("#mobileContact li").each(function(index) {
			$(this).addClass("i" + (index+1));
		});
		//fontselect
		$('#fontBig').bind('click', function(e){
			e.preventDefault();
			$('body').addClass('fontbig');
			$.cookie('fontbig', 1);
		});
		$('#fontSmall').bind('click', function(e){
			e.preventDefault();
			$('body').removeClass('fontbig');
			$.cookie('fontbig', null);
		});
		if ($.cookie('fontbig') == 1) {
			$('#fontBig').click();
		}
		$('#social .open').click(function() {
			var $this = $(this).parent();
			if ($this.hasClass('expand')) {
				$this.removeClass('expand');
				$this.stop().animate({width:'46px'});
			}
			else {
				$this.addClass('expand');
				$this.stop().animate({width:'290px'});
			}
		});
		$('#mainmenu li.level1').hover(function(){
				if($(this).find('.mmLevel2').length) {
					$('.listContainer',this).addClass('hover').show();
					$('a',this).addClass('hover');
				}
			},
			function(){
				$('.listContainer',this).removeClass('hover').hide();
				$('a',this).removeClass('hover');
			});
		$("#mainmenu .mmLevel2").easyListSplitter({
			colNumber: 2
		});
		$("#mainmenu .mmLevel2 li:last-child").addClass("lastli");
		$('#searchFilter .toggleSearchFilter').click(function() {
			$('.searchFilter #searchFilter form').toggle();
			$('.searchFilter #searchFilter').toggleClass('open');
		});

		bannerSize();
		$(window).resize(function() {
			bannerSize();
		});
		$(window).load(function () {
			bannerSize();
		});
		function bannerSize() {
			var body = $('body').width()

			if (body > 760) {
				$('body').addClass('carousel');
			}
			else {
				$('body').removeClass('carousel');
			}
		}
		var scrollPosition;
		$('#mobileBar .menuToggle').click(function(e) {
			e.preventDefault();
			var menuOpen = $('body').hasClass('open-menu');
			if (!menuOpen) {
				scrollPosition = $(window).scrollTop();
			}
			$('body').toggleClass('open-menu');
			$('#mMenu').toggle();
			$(this).toggleClass('open');
			if (!menuOpen) {
				$(window).scrollTop(0);
			}
			else {
				$(window).scrollTop(scrollPosition);
			}

			return false;
		});
		$('#mMenu .level1').prepend('<a class="expand" href="javascript:void(0)" title=""><span>+</span></a>');
		$('#mMenu .level2').prepend('<a class="expand" href="javascript:void(0)" title=""><span>+</span></a>');
		$('#mMenu .expand').click(function() {
			$('> ul',this.parentNode).toggle();
			$('> ul',this.parentNode).toggleClass('hide');
			$('> a',this.parentNode).toggleClass('down');
			//$(this).toggleClass('down');
		});

		$(window).scroll(function(){
			if($('body').hasClass('open-menu')) {

			}
			else {
				var minScroll = 40;
				var fClass = 'sticky';
				var scrollTop = $(window).scrollTop();
				if (scrollTop > minScroll){
					$('body').addClass(fClass);
				}else{
					$('body').removeClass(fClass);
				}
			}
		});
		$('#mMenu .selectedLevel1 a').addClass('down');
		$('#mMenu .selectedLevel1 .level2 a').removeClass('down');

		//Menu scroll
		if(document.addEventListener) {
			document.addEventListener("touchmove", ScrollStart, false);
			document.addEventListener("scroll", Scroll, false);
			var minScroll = ($('body').hasClass('frontpage')) ? 486 : 336;
			var fClass = 'sticky';
		}

		function ScrollStart() {
			var scrollTop = $(window).scrollTop();
			if (scrollTop > minScroll){
				$('#topMenu').addClass(fClass);
			}else{
				$('#topMenu').removeClass(fClass);
			}
		}
		function Scroll() {
			var minScroll = ($('body').hasClass('frontpage')) ? 486 : 336;
			var fClass = 'sticky';
			var scrollTop = $(window).scrollTop();
			if (scrollTop > minScroll){
				$('#topMenu').addClass(fClass);
			}else{
				$('#topMenu').removeClass(fClass);
			}
		}

		$('body').on('click', '#mainmenu .notLink > a', function(e) {
			e.preventDefault();
			return false;
		});
	}
};
site.hero = {
	init:function() {
		if (!$('body').hasClass('frontpage')) return false;
		if ($('#promo li').length > 1) {
			site.owl.init('#promo > ul', {
				loop: true,
				dots: true,
				nav: true,
				items: 1,
				navText: ['<i class=\"fa fa-angle-left\"></i>', '<i class=\"fa fa-angle-right\"></i>'],
				stopOnHover: true,
				autoplay: true,
				autoplayTimeout: 8500,
				autoplayHoverPause: true,
				animateOut: 'fadeOut',
				animateIn: 'fadeIn',
				onDrag: function () {
					$('#promo .owl-controls').hide();
				},
				onDragged: function () {
					$('#promo .owl-controls').show();
				},
				onInitialized: function() {
					$('#promo .owl-dot').keydown(function (e) {
						if (e.which == 13) {
							$(e.target).click();
						}
					});
				},
				onTranslated: function() {
					$('#promo .owl-item a').attr('tabindex', '-1');
					$('#promo .owl-item.active a').attr('tabindex', '4');
				}
			});
		}
	}
};

site.inits.push('site.hero.init()');

site.oldFixes = {
	init: function () {
		$('#footerBox > .box').wrap('<div class="innerWrap"></div>');
		$('#footerBox > .innerWrap').wrapAll('<div class="wrapper"></div>');
	}
};
site.inits.push('site.oldFixes.init()');

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});
	$('#mainmenu li.level1').hover(function(){
			if($(this).find('.mmLevel2').length) {
				$('.listContainer',this).addClass('hover').show();
				$('a',this).addClass('hover');
			}
		},
		function(){
			$('.listContainer',this).removeClass('hover').hide();
			$('a',this).removeClass('hover');
		});


	site.oldStyles.init();
	site.accessibility.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
